namespace $.$$ {
	export class $eve_app_page_components_switch extends $.$eve_app_page_components_switch {}
}

